import { i18n } from '../../../i18n/i18n'

import React, { Component, Fragment } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { RootState } from '../../../store'
import imageService from '../../../services/image.service'
import {
  ImageElement,
  replaceImageElementImage,
  replaceImageOpacity
} from '../../../views/LabelBuilder/LabelBuilder.slice'
import Heading from '../../Heading'
import InputFile from '../../InputFile'
import InputText from '../../InputText'
import PositionProperty from './PositionProperty'
import alertservice from '../../../services/alert.service'

interface Props {
  selectedElement: ImageElement
}

type CombinedProps = Props & ConnectedProps<typeof connector>

interface State {
  imageName: string
  image: File | null
}

const MAX_SIZE = 10 * 1024 * 1024 // 10 mb
const PERFORMANCE_WARNING_SIZE = 2 * 1024 * 1024 // 2 mb

class ImageProperties extends Component<CombinedProps, State> {
  constructor (props: CombinedProps) {
    super(props)
    this.state = {
      imageName: '',
      image: null
    }
    this.handleInputFileChange = this.handleInputFileChange.bind(this)
  }

  formatFileSize = (bytes: number): string => {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return `${(bytes / Math.pow(k, i)).toFixed(0)} ${sizes[i]}`
  }

  handleInputFileChange (
      name: string,
      file: File | null,
      filename: string,
      dataUri?: string
  ) {
    if (name === 'image') {
      const { selectedElement } = this.props
      if (!selectedElement || !file) return

      if (file.size > MAX_SIZE) {
        alertservice.error(
            i18n('file_size_too_big', {
              size: this.formatFileSize(file.size),
              max: '10 MB'
            })
        )
        return
      }

      this.setState({ image: file, imageName: filename })
      if (dataUri) {
        const { id } = selectedElement
        imageService.generateImage(dataUri, (image) => {
          this.props.replaceImageElementImage(id, image)
        })
      }
    }
  }

  handleInputChange = (name: string, value: string) => {
    const { selectedElement } = this.props
    if (!selectedElement) return
    const { id } = selectedElement
    if (name === 'opacity') this.props.replaceImageOpacity(id, Number(value))
  }

  render () {
    const { selectedElement } = this.props
    if (!selectedElement || selectedElement.type !== 'image') return

    return (
        <Fragment>
          <Heading
              className="mb-1"
              text={i18n('Image')}
              size="small"/>
          <PositionProperty
              elementId={selectedElement.id}
              x={selectedElement.x}
              y={selectedElement.y}
          />
          <InputFile
              name="image"
              filename={this.state.imageName}
              accept="image/*"
              label="Upload image"
              onChange={this.handleInputFileChange}/>
          <p className="text-[10px] text-gray-400 !mb-3">
            {i18n('image_performance_warning', { size: this.formatFileSize(PERFORMANCE_WARNING_SIZE) })}
          </p>
          <InputText
              type="number"
              name="opacity"
              value={String(selectedElement.opacity)}
              label={i18n('Transparency')}
              onChange={this.handleInputChange}
              enforceLimits={true}/>
        </Fragment>
    )
  }
}

function mapStateToProps (state: RootState) {
  return {}
}

const mapDispatchToProps = {
  replaceImageElementImage,
  replaceImageOpacity
}

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(ImageProperties)